import React from 'react'

export const UserProfile = () => {
  return (
    <div>UserProfile</div>
  )
}
